import { FC } from 'react'
import styled from 'styled-components'
import CheckmarkCircleIcon from '@tuhi/components/assets/icons/buttons/checkmarkCircle.svg'
import CircleOutlineIcon from '@tuhi/components/assets/icons/buttons/circleOutline.svg'

const iconSize = '1.5em'
export const Container = styled.div`
    width: ${iconSize};
    height: ${iconSize};
    background-color: ${(p) => p.theme.colors.white};
    border-radius: 50%;
`

export const CheckMarkContainer = styled.div`
    color: ${(p) => p.theme.colors.primaryGreen};
`

interface Props {
    selected?: boolean
    onClick: () => void
}

export const CheckMark: FC<Props> = ({ selected, onClick }) => {
    return (
        <CheckMarkContainer
            onClick={(event) => {
                event.stopPropagation()
                onClick()
            }}
        >
            <Container>
                {selected ? (
                    <span
                        style={{
                            width: iconSize,
                            height: iconSize,
                            display: 'inline-block',
                        }}
                    >
                        <CheckmarkCircleIcon />
                    </span>
                ) : (
                    <span
                        style={{
                            width: iconSize,
                            height: iconSize,
                            display: 'inline-block',
                        }}
                    >
                        <CircleOutlineIcon />
                    </span>
                )}
            </Container>
        </CheckMarkContainer>
    )
}
